export default __webpack_public_path__ + "static/media/step3.5bf1ad7c.webp";